import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ac52abc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { fill: "#ffffff" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "#ffffff",
    cx: "3",
    cy: "12",
    r: "2"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "#ffffff",
    cx: "12",
    cy: "12",
    r: "2"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "#ffffff",
    cx: "21",
    cy: "12",
    r: "2"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}